/**
 * TDF hostnames - these use /oauth2/session (no /internal prefix).
 *
 * Pattern: TDF uses "ess.{region}.barracudanetworks.com" format for prod,
 * and "ess.{region}.qa.cudaops.com" for some non-prod environments.
 * React APIGW uses "{region}.ess.{env}.com/api" format.
 *
 * Source: api-gateway/app/core/config.py (egd_api_url_tdf_* settings)
 */
const TDF_HOSTNAMES = new Set([
  // Production
  'ess.barracudanetworks.com', // US (no region prefix)
  'ess.au.barracudanetworks.com', // AU
  'ess.ca.barracudanetworks.com', // CA
  'ess.de.barracudanetworks.com', // DE
  'ess.in.barracudanetworks.com', // IN
  'ess.uk.barracudanetworks.com', // UK
  // Non-prod
  'ess.gt3.qa.cudaops.com', // GT3
  'ess.vt2.qa.cudaops.com', // VT2
  'ess.bt2.qa.cudaops.com', // BT2
  'ess.staging1.barracudanetworks.com', // STAGING1
  // Local
  'tdf.ess.qa.cudaops.com', // GT3
  'tdf.egd.qa.cudaops.com' // Local dev
])

/**
 * Get session endpoint URL for Login App FORM POST.
 *
 * TDF (CPL accounts): /oauth2/session
 * React (non-CPL): /internal/oauth2/session
 */
export const getLoginAppSessionEndpoint = (azp: string): string => {
  try {
    const url = new URL(azp)

    // Security: Only allow http(s) URLs to prevent javascript:, data:, etc.
    // http is allowed for localhost development only.
    const isHttps = url.protocol === 'https:'
    const isLocalHttp = url.protocol === 'http:' && url.hostname === 'localhost'
    if (!isHttps && !isLocalHttp) {
      throw new Error(`Invalid AZP protocol: ${url.protocol}`)
    }

    const isTdf = TDF_HOSTNAMES.has(url.hostname)
    const sessionPath = isTdf ? '/oauth2/session' : '/internal/oauth2/session'
    // Append session path to existing pathname, avoiding double slashes
    const basePath = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname
    url.pathname = basePath + sessionPath
    // Clear query and fragment - session endpoint doesn't use them
    url.search = ''
    url.hash = ''
    return url.toString()
  } catch {
    // Invalid URL or disallowed protocol - fail closed by throwing
    throw new Error(`Invalid AZP for session endpoint: ${azp}`)
  }
}
